<!-- <form [formGroup]="form">
  <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
</form> -->
<router-outlet></router-outlet>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" [baseZIndex]="baseZIndex"></p-confirmDialog>
<p-toast></p-toast>
<!-- <div *ngIf="isLoading" class="loader k-loading-mask ng-star-inserted"><span class="k-loading-text">Loading</span>
  <div class="k-loading-image"></div>
  <div class="k-loading-color"></div>
</div> -->
<div class="loaderCls" *ngIf="isLoading"></div>